import { useId } from "react";
import notify from "../../common/notify";
import { BudgetOptions } from "../../../data/seletboxOptions";
import SubCategory from "./SubCategory";
import { ReactComponent as RemoveRowIcon } from "../../../assets/img/common/trash-red-icon.svg";
import { useCallback } from "react";
import { useEffect } from "react";
const NumberItem = ({ index }) => {
  return (
    <span className="min-w-[32px] min-h-[32px] text-sm flex justify-center items-center rounded-full bg-primary text-white mr-3">
      {`${index + 1 < 10 && "0"}${index + 1}`}
    </span>
  );
};

const CustomSelectBox = ({ value, options, onChange, id }) => {
  return (
    <select
      id={id}
      onChange={onChange}
      value={value}
      className="w-full h-full non-appearance bg-transparent ml-2 px-2 focus:bg-[#f6f3f3] hover:bg-[#f4f1f1] rounded-md hover:cursor-pointer"
    >
      {options.map((item, index) => (
        <option key={item + index} value={item}>
          {item}
        </option>
      ))}
    </select>
  );
};

// MobileBudgetItem Component
const MobileBudgetItem = ({
  index,
  item,
  budgetsLength,
  formik,
  fomrikSetter,
}) => {
  // Destructure properties from the item or set default values
  const { subCategory, category } = item ?? {};
  const uId = useId();

  // Handle change in input fields
  const handleChangeField = (e) => {
    const budgetsClone = [...formik.values.budgets];
    budgetsClone[index][e.target.id] = e.target.value;

    // Reset subCategory names if category is "Other Expenses"
    if (budgetsClone[index][e.target.id] === "Other Expenses") {
      budgetsClone[index].subCategory.map((item) => {
        item.name = "";
        return item;
      });
    }

    fomrikSetter(budgetsClone);
  };

  // Handle deletion of a category
  const handleDeleteCategory = () => {
    let budgetsClone = [...formik.values.budgets];
    budgetsClone.splice(index, 1);
    fomrikSetter(budgetsClone);
  };

  // Render the MobileBudgetItem component
  return (
    <div className="w-full flex flex-col mb-5 bg-custom-gray-100 gap-y-3 rounded-[30px]">
      {/* Category Section */}
      <div className="w-full flex justify-between items-center h-12 py-2 px-3 rounded-[30px] bg-custom-gray-200 mr-4">
        <NumberItem index={index} />
        <CustomSelectBox
          id="category"
          options={Object.keys(BudgetOptions)}
          value={category}
          onChange={handleChangeField}
        />
        <button
          type="button"
          onClick={handleDeleteCategory}
          className="min-w-[32px] min-h-[32px] rounded-full text-sm flex justify-center items-center ml-3"
        >
          <RemoveRowIcon />
        </button>
      </div>

      {/* SubCategory Section */}
      <div className="w-full flex flex-col">
        {subCategory.map((item, subIndex, arr) => (
          <SubCategory
            key={`${index + 1 * subIndex}_${uId}`}
            category={category}
            index={subIndex}
            item={item}
            subCategoryLength={arr.length}
            subCategory={subCategory}
            budgetIndex={index}
            formik={formik}
          />
        ))}
      </div>
    </div>
  );
};

// DesktopBudgetItem Component
const DesktopBudgetItem = ({
  index,
  item,
  budgetsLength,
  formik,
  fomrikSetter,
}) => {
  // Destructure properties from the item or set default values
  const { subCategory, category } = item ?? {};
  const uId = useId();

  // Handle change in input fields
  const handleChangeField = (e) => {
    const budgetsClone = [...formik.values.budgets];
    budgetsClone[index][e.target.id] = e.target.value;

    // Reset subCategory names if category is "Other Expenses"
    if (budgetsClone[index][e.target.id] === "Other Expenses") {
      budgetsClone[index].subCategory.map((item) => {
        item.name = "";
        return item;
      });
    }

    fomrikSetter(budgetsClone);
  };

  // Handle deletion of a category
  const handleDeleteCategory = () => {
    let budgetsClone = [...formik.values.budgets];
    budgetsClone.splice(index, 1);
    fomrikSetter(budgetsClone);
  };

  // Render the DesktopBudgetItem component
  return (
    <div className="w-full flex justify-between mb-5">
      {/* Category Section */}
      <div className="w-[24%] min-w-[80px] flex justify-between items-center h-12 py-2 px-3 rounded-full bg-custom-gray-200 mr-4">
        <NumberItem index={index} />
        <CustomSelectBox
          id="category"
          options={Object.keys(BudgetOptions)}
          value={category}
          onChange={handleChangeField}
        />
        <button
          type="button"
          onClick={handleDeleteCategory}
          className="min-w-[32px] min-h-[32px] rounded-full text-sm flex justify-center items-center ml-3"
        >
          <RemoveRowIcon />
        </button>
      </div>

      {/* SubCategory Section */}
      <div className="w-[76%] flex flex-col">
        {subCategory.map((item, subIndex, arr) => (
          <SubCategory
            key={`${index + 1 * subIndex}_${uId}`}
            category={category}
            index={subIndex}
            item={item}
            subCategoryLength={arr.length}
            subCategory={subCategory}
            budgetIndex={index}
            formik={formik}
          />
        ))}
      </div>
    </div>
  );
};

// BudgetAllocation Component
const BudgetAllocation = ({ formik }) => {
  // Function to set budgets field value in formik
  const fomrikSetter = (val) => {
    formik.setFieldValue("budgets", val);
  };

  // Function to calculate total budget and update formik values
  const calcTotalBudget = useCallback(() => {
    let totalBudgets = [...formik.values.budgets];
    let totalBudget = 0;

    totalBudgets.forEach((category) => {
      category.subCategory.forEach((subCategory) => {
        totalBudget += Number(subCategory.budget);
      });
    });

    formik.setFieldValue("total_budget", Number(totalBudget.toFixed(6)));
  }, [formik.values.budgets]);

  // Effect to recalculate total budget on budget changes
  useEffect(() => {
    calcTotalBudget();
  }, [formik.values.budgets]);

  // Function to check if subCategory fields are filled
  const checkSubCategoryFieldsValue = () => {
    if (formik.values.budgets.length === 0) return true;
    if (!formik?.errors?.budgets) return true;
    return false;
  };

  // Function to handle adding a new category
  const handleAddCategory = () => {
    let budgetsClone = [...formik.values.budgets];

    if (checkSubCategoryFieldsValue()) {
      budgetsClone.push({
        category: "Personnel",
        subCategory: [
          {
            name: "Researcher Salary",
            detail: "",
            budget: 0.1,
          },
        ],
      });
      fomrikSetter(budgetsClone);
    } else {
      formik.setFieldTouched("budgets", true);
      notify("Please fill in all the fields correctly", "error");
    }
  };

  // Retrieve budgets error message
  let budgets_error = formik?.errors?.budgets;

  // Render the BudgetAllocation component
  return (
    <div className="w-full flex flex-col">
      {/* Budget Allocation Title and Description */}
      <h3 className="mt-14 text-xl abel-font font-semibold">
        Budget Allocation
      </h3>
      <p className="mt-2 mb-6">
        The Project Budget Statement typically includes a detailed breakdown of
        all the expenditures required for carrying out the project, such as
        labor costs, equipment expenses, materials costs, overheads, and any
        other associated costs. By outlining the expense categories included in
        your projects, it would provide a clear understanding of how the
        obtained funds will be utilized.
      </p>

      {/* Display budgets error message if available */}
      {formik?.touched?.budgets &&
      typeof budgets_error === "string" &&
      budgets_error ? (
        <p className="text-red-500 mb-4">{budgets_error}</p>
      ) : null}

      {/* Desktop view of budget items */}
      <div className="w-full hidden mlg:flex flex-col" id="budgets">
        {formik?.values?.budgets?.map((item, index, arr) => (
          <DesktopBudgetItem
            key={"budget_" + index}
            index={index}
            item={item}
            budgetsLength={arr.length}
            formik={formik}
            fomrikSetter={fomrikSetter}
          />
        ))}
      </div>

      {/* Mobile view of budget items */}
      <div className="w-full flex flex-col mlg:hidden" id="budgets">
        {formik?.values?.budgets?.map((item, index, arr) => (
          <MobileBudgetItem
            key={"budget_" + index}
            index={index}
            item={item}
            budgetsLength={arr.length}
            formik={formik}
            fomrikSetter={fomrikSetter}
          />
        ))}
      </div>

      {/* Button to add a new category */}
      <div className="w-full flex justify-center items-center h-12 py-2 rounded-full bg-custom-gray-200">
        <button
          type="button"
          onClick={handleAddCategory}
          className="flex items-center  rounded-full group relative"
        >
          <span className="w-8 h-8 rounded-full absolute left-0 top-0 group-hover:w-full group-hover:bg-white transition-all duration-300 ease-in"></span>
          <span className="w-8 h-8 rounded-full flex justify-center items-center z-10 bg-white text-[#3C2166] ">
            +
          </span>
          <span className="font-medium ml-2 z-10 pr-3">Add Category</span>
        </button>
      </div>

      {/* Display total budget */}
      <div className="w-full flex gap-1 items-center justify-end my-6 font-semibold">
        <span>Total Budget : </span>
        <span className="text-primary mr-4">
          {" "}
          ${formik?.values?.total_budget || 0}{" "}
        </span>
      </div>
    </div>
  );
};

// Export the BudgetAllocation component
export default BudgetAllocation;
